import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RecommendationEditPageRoutingModule } from './recommendation-edit-routing.module';

import { RecommendationEditPage } from './recommendation-edit.page';
import { CustomerAndAddressCardModule } from 'src/app/components/customer-and-address-card/customer-and-address-card.module';
import { CardSkeletonModule } from 'src/app/components/card-skeleton/card-skeleton.module';
import { AutocompleteModule } from 'src/app/components/autocomplete/autocomplete.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RecommendationEditPageRoutingModule,
    CustomerAndAddressCardModule,
    CardSkeletonModule,
    AutocompleteModule,
    PipesModule
  ],
  declarations: [RecommendationEditPage]
})
export class RecommendationEditPageModule {}
